declare var productDetailsParams: any;

var loadMoreBtn = document.getElementById("loadMoreReviews");

if (loadMoreBtn != null) {
    loadMoreBtn.addEventListener("click", function () {
        var reviewsContainer = document.getElementsByClassName('reviews-items')!.item(0)!;
        var reviewsRendered = document.getElementsByClassName('review-item').length;
        const reviewsToRetrieve = productDetailsParams.ReviewsToDisplay + reviewsRendered;

        fetch(`${productDetailsParams.GetProductReviewsURL}&noOfReviews=${reviewsToRetrieve}&offset=0`, {
            method: 'GET'
        }).then(response => response.text())
            .then(function (data) {
                reviewsContainer.innerHTML = data;

                if (reviewsToRetrieve >= productDetailsParams.ReviewsCount) {
                    loadMoreBtn!.style.display = "none";
                }
            });
    });
}
